import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Props from '@components/Props';
export const _frontmatter = {
  "name": "Newsletter",
  "menu": "Components",
  "route": "/components/newsletter",
  "description": "The API documentation of the Newsletter React component. Play around with demos and check out its props."
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Newsletter`}</h1>
    <p><strong parentName="p">{`Newsletter`}</strong>{` provides you with a built-in form to handle your emailing list, with a light interface to add text content
around.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/newsletter#"
        }}>{`Newsletter`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/newsletter#newsletter-input"
        }}>{`Newsletter.Input`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/newsletter#newsletter-button"
        }}>{`Newsletter.Button`}</a></li>
    </ul>
    <h2>{`Default`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
() => {
  const [email, setEmail] = React.useState('')

  return (
    <Newsletter
      title='Subscribe to our newsletter'
      description='Get exclusive offers every week!'
      caption="By subscribing, you agree to receive emails from us. Don't worry, we are not spamers :)"
    >
      <Newsletter.Input id="email" placeholder="Email..." value={email} onChange={e => setEmail(e.target.value)} />
      <Newsletter.Button onClick={() => console.log('Thanks for subscribing!')}>
        Subscribe
      </Newsletter.Button>
    </Newsletter>
  )
}
`}</code></pre>
    <h2>{`No caption`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
() => {
  const [email, setEmail] = React.useState('')

  return (
    <Newsletter
      title='Subscribe to our newsletter'
      description='Get exclusive offers every week!'
    >
      <Newsletter.Input id="email" placeholder="Email..." value={email} onChange={e => setEmail(e.target.value)} />
      <Newsletter.Button onClick={() => console.log('Thanks for subscribing!')}>
        Subscribe
      </Newsletter.Button>
    </Newsletter>
  )
}
`}</code></pre>
    <h2>{`No description`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
() => {
  const [email, setEmail] = React.useState('')

  return (
    <Newsletter
      title='Subscribe to our newsletter'
      caption="By subscribing, you agree to receive emails from us. Don't worry, we are not spamers :)"
    >
      <Newsletter.Input id="email" placeholder="Email..." value={email} onChange={e => setEmail(e.target.value)} />
      <Newsletter.Button onClick={() => console.log('Thanks for subscribing!')}>
        Subscribe
      </Newsletter.Button>
    </Newsletter>
  )
}
`}</code></pre>
    <h2>{`Title only`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
() => {
  const [email, setEmail] = React.useState('')
  return (
    <Newsletter
      title='Subscribe to our newsletter'
    >
      <Newsletter.Input id="email" placeholder="Email..." value={email} onChange={e => setEmail(e.target.value)} />
      <Newsletter.Button onClick={() => console.log('Thanks for subscribing!')}>
        Subscribe
      </Newsletter.Button>
    </Newsletter>
  )
}
`}</code></pre>
    <h2>{`Custom controls`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
() => {
const [email, setEmail] = React.useState('')

return (
  <Newsletter
    title='Subscribe to our newsletter'
    description='Get exclusive offers every week!'
    caption="By subscribing, you agree to receive emails from us. Don't worry, we are not spamers :)"
  >
    <input id="email" placeholder="Email..." type="email" value={email} onChange={e => setEmail(e.target.value)}/>
    <button onClick={() => console.log('Thanks for subscribing!')}>
      Subscribe
    </button>
  </Newsletter>
)
}
`}</code></pre>
    <h2>{`Extended`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live-extended
<ExtendedNewsletter />
`}</code></pre>
    <h2>{`Props`}</h2>
    <Props of="Newsletter" mdxType="Props" />
    <br />
    <hr />
    <h2>{`Newsletter.Button`}</h2>
    <h3>{`Default Button`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Newsletter.Button onClick={() => console.log('Thanks for subscribing!')}>
  Subscribe
</Newsletter.Button>
`}</code></pre>
    <h3>{`Various props`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Newsletter.Button
  color="secondary"
  endIcon={<span>:)</span>}
  size="large"
  onClick={() => console.log('Thanks for subscribing!')}
>
  Subscribe now
</Newsletter.Button>
`}</code></pre>
    <h3>{`Extended`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live-extended
<ExtendedNewsletterButton onClick={() => console.log('Thanks for subscribing!')}>
  Subscribe now
</ExtendedNewsletterButton>
`}</code></pre>
    <h3>{`Props`}</h3>
    <p>{`This component extends Material's UI `}<inlineCode parentName="p">{`<Button>`}</inlineCode>{` so you can use all its props as well. Check out its `}<a parentName="p" {...{
        "href": "https://material-ui.com/api/button/"
      }}>{`Api`}</a>{`.`}</p>
    <Props of="Newsletter.Button" mdxType="Props" />
    <br />
    <hr />
    <h2>{`Newsletter.Input`}</h2>
    <h3>{`Default Input`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
() => {
  const [email, setEmail] = React.useState('')

  return <Newsletter.Input id="email" placeholder="Email..." value={email} onChange={e => setEmail(e.target.value)} />
}
`}</code></pre>
    <h3>{`Various props`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
() => {
  const [email, setEmail] = React.useState('')
  return (
    <Newsletter.Input
      endAdornment={<span>:)</span>}
      id="email"
      color="secondary"
      placeholder="components-extra@gmail.com"
      value={email}
      onChange={e => setEmail(e.target.value)}
      label="Email"
    />
  )
}
`}</code></pre>
    <h3>{`Error state`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
() => {
  const [email, setEmail] = React.useState('')
  return (
    <Newsletter.Input
      error
      id="email"
      placeholder="components-extra@gmail.com"
      value={email}
      onChange={e => setEmail(e.target.value)}
    />
  )
}
`}</code></pre>
    <h3>{`Extended`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live-extended
<ExtendedInputStory />
`}</code></pre>
    <h3>{`Props`}</h3>
    <p>{`This component extends Material's UI `}<inlineCode parentName="p">{`<OutlinedInput>`}</inlineCode>{` so you can use all its props as well. Check out its `}<a parentName="p" {...{
        "href": "https://material-ui.com/api/outlined-input/"
      }}>{`Api`}</a>{`.`}</p>
    <Props of="Newsletter.Input" mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      